import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useForm } from '@/form/useForm.ts';

export const AncestrySummaryFormIN = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['ancestry'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  //  tongueMother, tongueFather

  const stateFatherField = addReqiredMessage({
    field: s.ancestry.fields.find(({ name }) => name === 'stateFather'),
    message: s.dataSummary.requiredMessage!,
  });
  const stateFatherLabel = translate(stateFatherField?.label);
  const stateFatherValue =
    translate(stateFatherField?.options?.find(({ value }) => value === getFieldValue('stateFather'))?.label) ||
    getFieldValue('stateFather');

  const motherTongueFatherField = s.ancestry.fields.find(({ name }) => name === 'motherTongueFather');
  const motherTongueFatherLabel = translate(motherTongueFatherField?.label);
  const motherTongueFatherValue =
    translate(
      motherTongueFatherField?.options?.find(({ value }) => value === getFieldValue('motherTongueFather'))?.label
    ) || getFieldValue('motherTongueFather');

  const stateMotherField = addReqiredMessage({
    field: s.ancestry.fields.find(({ name }) => name === 'stateMother'),
    message: s.dataSummary.requiredMessage!,
  });
  const stateMotherLabel = translate(stateMotherField?.label);
  const stateMotherValue =
    translate(stateMotherField?.options?.find(({ value }) => value === getFieldValue('stateMother'))?.label) ||
    getFieldValue('stateMother');

  const motherTongueMotherField = s.ancestry.fields.find(({ name }) => name === 'motherTongueMother');
  const motherTongueMotherLabel = translate(motherTongueMotherField?.label);
  const motherTongueMotherValue =
    translate(
      motherTongueMotherField?.options?.find(({ value }) => value === getFieldValue('motherTongueMother'))?.label
    ) || getFieldValue('motherTongueMother');

  return (
    <div className="summary-card" data-cy={'summary-form-ancestry'}>
      <h2>{translate(s.dataSummary.titles?.ancestry)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{stateFatherLabel} (Father)</div>
        <div className={'value'}>
          {!editMode && stateFatherValue}
          {editMode && <EditDataField field={stateFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{motherTongueFatherLabel} (Father)</div>
        <div className={'value'}>
          {!editMode && motherTongueFatherValue}
          {editMode && <EditDataField field={motherTongueFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{stateMotherLabel} (Mother)</div>
        <div className={'value'}>
          {!editMode && stateMotherValue}
          {editMode && <EditDataField field={stateMotherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{motherTongueMotherLabel} (Mother)</div>
        <div className={'value'}>
          {!editMode && motherTongueMotherValue}
          {editMode && <EditDataField field={motherTongueMotherField!} slideId={'ancestry'} />}
        </div>
      </div>
    </div>
  );
};
